import { defineMessages } from '@atlassian/jira-intl';

export const multipleRolesText = defineMessages({
	roleMessage: {
		id: 'users-and-roles.common.role-message',
		defaultMessage: 'Multiple ({count} roles)',
		description:
			'Dropdown label. Is shown to user when they apply multiple roles filter. {count} refer to count of roles selected',
	},
});
